var N = /* @__PURE__ */ ((_) => (_.NamedFlagWithExpansionOnClick = "NAMED_FLAG_WITH_EXPANSION_ON_CLICK", _.FlagWithExpansionOnClick = "FLAG_WITH_EXPANSION_ON_CLICK", _.FlagWithExpansionOnHover = "FLAG_WITH_EXPANSION_ON_HOVER", _))(N || {});
export {
  N as Variants
};
//# sourceMappingURL=index.js.map
